import { useWindowSize } from "@uidotdev/usehooks";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import FPTLogo from "../assets/imgs/media/logoFpt.svg";
import ZaloLogo from "../assets/imgs/media/logoZaloAds.png";
import NewsLogo from "../assets/imgs/media/tapchinganghang.png";

const dataMedia = [
  {
    id: 1,
    img: FPTLogo,
    title: "media.item.des1",
  },
  {
    id: 2,
    img: ZaloLogo,
    title: "media.item.des2",
  },
  {
    id: 3,
    img: NewsLogo,
    title: "media.item.des3",
  },
];

export default function Media() {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  return (
    <div>
      <Helmet>
        <title>{t("media.title")} | Trusted Pay</title>
      </Helmet>
      <div className="mt-[80px]">
        <div className="flex flex-col items-center gap-[10px] bg-[#EFF0FF] px-4 py-[50px]">
          <h1 className="text-center sm600:text-5xl text-[64px] font-[700] capitalize not-italic leading-[70px] tracking-[-0.5px] text-[#565ADD]">
            {t("media.title")}
          </h1>
          <div className="flex flex-col items-start self-stretch pb-5">
            <div className="mx-auto my-0 flex w-[18%] items-start self-stretch py-0">
              <span className="w-full self-stretch border-t-[5px] border-solid border-[#565ADD]"></span>
            </div>
          </div>
          <div className="flex flex-col items-center self-stretch px-2">
            <p className="py-0 text-center font-semibold text-[#2B1C50]">
              {t("media.des1")}{" "}
              <span className="cursor-pointer text-[#565ADD] hover:underline">
                {t("media.des2")}
              </span>{" "}
              {t("media.des3")}
              {width > 768 ? <br /> : null}
              {t("media.des4")}
            </p>
          </div>
        </div>
      </div>
      {/* section2 */}
      <div className="w-full animate-fadeInLeft pb-[50px] pt-[24px] px-4">
        <div className="mx-auto max-w-[1280px]">
          <div className="grid grid-cols-3 gap-[10px] lg:grid-cols-2 sm600:grid-cols-1 w-full">
            {dataMedia.map((item) => (
              <div
                key={item.id}
                className="group mx-auto mt-[26px] grid cursor-pointer place-items-center w-full overflow-hidden text-[#2B1C50] hover:text-[#565ADD]"
              >
                <div className="grid h-[240px] w-full max-w-[420px] place-items-center overflow-hidden rounded-lg border">
                  <img
                    src={item.img}
                    alt="logo"
                    className="block object-center transition ease-in-out group-hover:-translate-y-1 group-hover:scale-105"
                  />
                </div>
                <p className="mt-[20px] text-center text-[18px] font-semibold leading-[22px]">
                  {t(item.title)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
